import { format, parseISO } from "date-fns";
import { Link } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";

const BlogDetails = ({ blog }) => {
  return (
    <div className="container">
      <div className="flex flex-wrap items-center justify-around rounded-lg px-2 py-2 text-lg font-medium sm:text-xl md:mx-10 md:px-10">
        <div className="m-3 transition-all duration-100 hover:scale-110">
          <a
            href={blog.authorContact}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium underline underline-offset-4"
          >
            {blog.author}
          </a>
        </div>
        <time className="m-3">
          {format(parseISO(blog.datePublished), "LLLL d, yyyy")}
        </time>
        <div className="m-3">{blog.readingTime} min read</div>
        <Link
          to={`/blog-categories/${blog.tags[0]}`}
          className="m-3 capitalize transition-all duration-100 hover:scale-110"
        >
          #{blog.tags[0]}
        </Link>
      </div>
      <div className="flex justify-center">
        <div className="mt-0 inline-flex items-center justify-center space-x-3 rounded-lg bg-neutral-800 px-4 py-3 text-[15.6px] dark:text-blue-200">
          <div className="shrink-0">
            <FaInfoCircle />
          </div>
          <div className="[&>p]:my-0">
            <p className="leading-7 [&:not(:first-child)]:mt-6">
              This blog is provided for and written by{"  "}
              <a
                className="font-medium underline underline-offset-4"
                href="https://www.bafarlabs.com"
              >
                BAFAR LABS
              </a>{" "}
              . Stay tuned for more insights and updates from our team!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
